module.exports = __webpack_public_path__ + "img/404.68687f05.png";